const page = require('../../../../../components/page/page')
const emailTrackingDt = require('./emailTracking-dt')

import emailTrackingPage from './emailTracking-page.html';

/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page on the body
function HTMLselect(detail) {

      HTMLwasSelected = true

      const body = document.body
      body.insertAdjacentHTML('beforeend', emailTrackingPage)

      emailTrackingDt.start({
            dest: 'emailTracking',
            elem: 'dt',
            act: 'select',
            entity: 'emailTracking'
      })

}/**/

/****************ELEMENTS*****************/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}

const obj = {

      show: { start: (detail) => { page.start(detail) } },

}/**/
